// import React, { useEffect, useState } from "react";
// import "../../styles/institutions.css";
// import logo from "../../assets/Loginimg/male.png";
// import { useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { getWithTokenAPI, putWithTokenAPI } from "../../util/Api";
// import SelectDropdown from "../ReusableComponent/SelectDropdown";

// import { Eye } from "lucide-react";
// import { InstitutionCardSkeleton } from "../ReusableComponent/TableSkeleton";
// import { SafeToast } from "../Toast/ShowToast";

// const InstitutionsCom = () => {
//     const { token, roleType } = useSelector((state) => state.auth);
//     const navigate = useNavigate();
//     const [loading, setLoading] = useState(true);

//     const [institutionsData, setInstitutionsData] = useState([]);
//     const [state, setState] = useState("");
//     const [month, setMonth] = useState("");
//     const [year, setYear] = useState("");
//     const stateOptions = [
//         { value: "TN", label: "Tamil Nadu" },
//         { value: "KL", label: "Kerala" },
//         { value: "KA", label: "Karnataka" },
//     ];

//     const monthOptions = [
//         { value: "12", label: "12 Months" },
//         { value: "6", label: "6 Months" },
//         { value: "3", label: "3 Months" },
//     ];

//     const yearOptions = [
//         { value: "2024", label: "2024" },
//         { value: "2023", label: "2023" },
//         { value: "2022", label: "2022" },
//     ];

//     const fetchInstitutions = async () => {
//         try {
//             setLoading(true);
//             const res = await getWithTokenAPI(
//                 token,
//                 "/user/getall?roleType=institution_admin"
//             );
//             setInstitutionsData(res.data.data || []);
//         } catch (error) {
//             console.error("Failed to fetch institutions");
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         if (!token) return;
//         fetchInstitutions();
//     }, [token]);

//     const handleBlock = async (item) => {
//         console.log(item, "item")
//         const payload = {
//             is_block: !item.is_block, // toggle
//         };

//         const action = item.is_block ? "Unblocked" : "Blocked";

//         try {
//             const res = await putWithTokenAPI(
//                 token,
//                 `/user/update/${item._id}`,
//                 payload
//             );

//             if (res?.statusCode === 200) {
//                 SafeToast.success(`Student ${action} successfully`);
//                 fetchInstitutions()
//             } else {
//                 SafeToast.error(res?.message || "Failed to update student status");
//             }
//         } catch (error) {
//             console.error("Error updating student status:", error);
//             SafeToast.error("Failed to update student status");
//         }
//     };

//     const Handleview = (item) => {
//         navigate(`/institution/${item._id}`);
//     };
//     return (
//         <div className="institutions-page">
//             <div className="institutions-header">
//                 <h2 className="main-title">Institutions</h2>
//                 <div className="filters">
//                     <SelectDropdown
//                         value={state}
//                         onChange={setState}
//                         options={stateOptions}
//                         placeholder="State"
//                     />

//                     <SelectDropdown
//                         value={month}
//                         onChange={setMonth}
//                         options={monthOptions}
//                         placeholder="Months"
//                     />

//                     <SelectDropdown
//                         value={year}
//                         onChange={setYear}
//                         options={yearOptions}
//                         placeholder="Year"
//                     />
//                 </div>
//             </div>

//             <div className="institutions-grid">
//                 {loading
//                     ? Array.from({ length: 6 }).map((_, index) => (
//                         <InstitutionCardSkeleton key={index} />
//                     ))
//                     :
//                     institutionsData.map((item, index) => (
//                         <div className="institution-card" key={index}>
//                             <div className="two-col-grid">
//                                 <div>
//                                     <div>
//                                         <span className="inst-name-institutions">{item.name}</span>
//                                     </div>

//                                     <div className="stats-section">
//                                         <h3 className="count">{item.totalUsers}</h3>
//                                         <p className="sub-text">Students Utilizing</p>
//                                     </div>
//                                 </div>
//                                 <div>
//                                     {item.logo ? (
//                                         <img className="inst-logo-institutions" src={item.logo} alt="logo" />
//                                     ) : (
//                                         <div className="placeholder-logo">KA</div>
//                                     )}
//                                 </div>
//                             </div>

//                             <div
//                                 style={{
//                                     display: "flex",
//                                     gap: "12px",
//                                     marginTop: "12px",
//                                 }}
//                             >
//                                 <button
//                                     style={{
//                                         flex: 1,
//                                         backgroundColor: "#0066ff",
//                                         color: "#fff",
//                                         border: "none",
//                                         padding: "8px",
//                                         borderRadius: "8px",
//                                         fontSize: "14px",
//                                         fontWeight: 600,
//                                         cursor: "pointer",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         justifyContent: "center",
//                                         gap: "6px",
//                                     }}
//                                     onClick={() => { Handleview(item) }}
//                                 >
//                                     <Eye size={18} /> View
//                                 </button>

//                                 <button
//                                     className={`inst-block-btn ${item.is_block ? "unblock" : "block"}`}
//                                     onClick={() => handleBlock(item)}
//                                 >
//                                     {item.is_block ? "Unblock" : "Block"}
//                                 </button>
//                             </div>

//                         </div>
//                     ))}
//             </div>
//         </div>
//     );
// };

// export default InstitutionsCom;

import React, { useEffect, useState } from "react";
import "../../styles/institutions.css";
import logo from "../../assets/Loginimg/male.png";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getWithTokenAPI, putWithTokenAPI } from "../../util/Api";
import SelectDropdown from "../ReusableComponent/SelectDropdown";
import { Eye } from "lucide-react";
import { Country, State, City } from "country-state-city";
import { InstitutionCardSkeleton } from "../ReusableComponent/TableSkeleton";
import { SafeToast } from "../Toast/ShowToast";

const InstitutionsCom = () => {
  const { token, roleType } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const [institutionsData, setInstitutionsData] = useState([]);
  const [state, setState] = useState(null);
  const [month, setMonth] = useState(null);
  const [year, setYear] = useState(null);

  const [appliedFilters, setAppliedFilters] = useState({
    state: null,
    month: null,
    year: null,
  });
  const [debounceTimer, setDebounceTimer] = useState(null);

  const [stateOptions, setStateOptions] = useState([]);
  useEffect(() => {
    const indianStates = State.getStatesOfCountry("IN");
    const formattedStates = indianStates.map((state) => ({
      value: state.isoCode,
      label: state.name,
    }));
    setStateOptions(formattedStates);
  }, []);

  // const stateOptions = [
  //     { value: "Karnataka", label: "Karnataka" },
  //     { value: "Tamil Nadu", label: "Tamil Nadu" },
  //     { value: "Kerala", label: "Kerala" },
  //     { value: "Andhra Pradesh", label: "Andhra Pradesh" },
  //     { value: "Telangana", label: "Telangana" },
  //     { value: "Maharashtra", label: "Maharashtra" },
  //     { value: "Delhi", label: "Delhi" },
  // ];

  const monthOptions = [
    { value: "1", label: "January" },
    { value: "2", label: "February" },
    { value: "3", label: "March" },
    { value: "4", label: "April" },
    { value: "5", label: "May" },
    { value: "6", label: "June" },
    { value: "7", label: "July" },
    { value: "8", label: "August" },
    { value: "9", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  // Generate years dynamically (current year to 5 years back)
  const getYearOptions = (startYear = 2020) => {
    const currentYear = new Date().getFullYear() + 1;
    const years = [];

    for (let year = currentYear; year >= startYear; year--) {
      years.push({
        value: year,
        label: `${year}`,
      });
    }

    return years;
  };
  const yearOptions = getYearOptions(2025);

  // Function to build API URL with filters
  const buildApiUrl = (filters) => {
    let url = "/user/getall?roleType=institution_admin&all=true";

    if (filters.state!=null) {
      url += `&state=${encodeURIComponent(filters.state)}`;
    }

    if (filters.month!=null) {
      url += `&month=${filters.month}`;
    }

    if (filters.year!=null) {
      url += `&year=${filters.year}`;
    }

    return url;
  };

  // Fetch institutions with filters
  const fetchInstitutions = async (filters = {}) => {
    try {
      setLoading(true);
      const url = buildApiUrl(filters);
      const res = await getWithTokenAPI(token, url);
      setInstitutionsData(res.data.data || []);
    } catch (error) {
      console.error("Failed to fetch institutions:", error);
      SafeToast.error("Failed to load institutions");
    } finally {
      setLoading(false);
    }
  };

  // Initial fetch on component mount
  useEffect(() => {
    if (!token) return;
    fetchInstitutions();
  }, [token]);

  // Handle filter changes with debouncing
  const handleFilterChange = (type, value) => {
    // Update local state
    if (type === "state") setState(value);
    if (type === "month") setMonth(value);
    if (type === "year") setYear(value);

    // Update applied filters
    const newFilters = {
      ...appliedFilters,
      [type]: value,
    };

    setAppliedFilters(newFilters);

    // Clear existing timer
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }

    // Set new debounce timer
    const timer = setTimeout(() => {
      fetchInstitutions(newFilters);
    }, 500); // 500ms debounce delay

    setDebounceTimer(timer);
  };

  const handleClearFilters = () => {
    setState(null);
    setMonth(null);
    setYear(null);
    setAppliedFilters({
      state: null,
      month: null,
      year: null,
    });
    fetchInstitutions();
  };

  const handleBlock = async (item) => {
    const payload = {
      is_block: !item.is_block,
    };

    const action = item.is_block ? "Unblocked" : "Blocked";

    try {
      const res = await putWithTokenAPI(
        token,
        `/user/update/${item._id}`,
        payload,
      );

      if (res?.statusCode === 200) {
        SafeToast.success(`Institution ${action} successfully`);
        fetchInstitutions(appliedFilters);
      } else {
        SafeToast.error(res?.message || "Failed to update institution status");
      }
    } catch (error) {
      console.error("Error updating institution status:", error);
      SafeToast.error("Failed to update institution status");
    }
  };

  const Handleview = (item) => {
    navigate(`/institution/${item._id}`);
  };

  // Cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
    };
  }, [debounceTimer]);

  return (
    <div className="institutions-page">
      <div className="institutions-header">
        <h2 className="main-title">Institutions</h2>

        {/* Filter section with apply/clear buttons */}
        <div className="filters-section">
          <div className="filters">
            <SelectDropdown
              value={state}
              onChange={(value) => handleFilterChange("state", value)}
              options={stateOptions}
              placeholder="Select State"
              width={"200px"}
            />

            <SelectDropdown
              value={month}
              onChange={(value) => handleFilterChange("month", value)}
              options={monthOptions}
              placeholder="Select Month"
              width={"200px"}
            />

            <SelectDropdown
              value={year}
              onChange={(value) => handleFilterChange("year", value)}
              options={yearOptions}
              placeholder="Select Year"
              width={"200px"}
            />
          </div>
        </div>
      </div>

      {/* Show active filters */}
      {(appliedFilters.state ||
        appliedFilters.month ||
        appliedFilters.year) && (
        <div
          className="active-filters"
          style={{
            marginBottom: "20px",
            padding: "10px",
            backgroundColor: "#f0f9ff",
            borderRadius: "8px",
            border: "1px solid #bae6fd",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <span style={{ fontWeight: "400", color: "#0369a1" }}>
              Active Filters :
            </span>

            {appliedFilters.state && (
              <span
                className="filter-tag"
                style={{ padding: "4px 12px 4px 0px" }}
              >
                State: {appliedFilters.state}
              </span>
            )}

            {appliedFilters.month && (
              <span className="filter-tag" style={{ padding: "4px 12px" }}>
                Month:{" "}
                {
                  monthOptions.find((m) => m.value === appliedFilters.month)
                    ?.label
                }
              </span>
            )}

            {appliedFilters.year && (
              <span className="filter-tag" style={{ padding: "4px 12px" }}>
                Year: {appliedFilters.year}
              </span>
            )}
          </div>

          <button className="edit-phone-btn" onClick={handleClearFilters}>
            Clear All
          </button>
        </div>
      )}

      <div className="institutions-grid">
        {loading ? (
          Array.from({ length: 6 }).map((_, index) => (
            <InstitutionCardSkeleton key={index} />
          ))
        ) : institutionsData.length > 0 ? (
          institutionsData.map((item, index) => (
            <div className="institution-card" key={index}>
              <div className="two-col-grid">
                <div>
                  <div>
                    <span className="inst-name-institutions">
                      {item.nameofInstitution}
                    </span>
                  </div>

                  <div className="stats-section">
                    <h3 className="count">{item.totalUsers}</h3>
                    <p className="sub-text">Students Utilizing</p>
                  </div>
                </div>
                <div>
                  {item.logo ? (
                    <img
                      className="inst-logo-institutions"
                      src={item.logo}
                      alt="logo"
                    />
                  ) : (
                    <div className="placeholder-logo">KA</div>
                  )}
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  marginTop: "12px",
                }}
              >
                <button
                  style={{
                    flex: 1,
                    backgroundColor: "#0066ff",
                    color: "#fff",
                    border: "none",
                    padding: "8px",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: 600,
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "6px",
                  }}
                  onClick={() => {
                    Handleview(item);
                  }}
                >
                  <Eye size={18} /> View
                </button>

                <button
                  className={`inst-block-btn ${item.is_block ? "unblock" : "block"}`}
                  onClick={() => handleBlock(item)}
                >
                  {item.is_block ? "Unblock" : "Block"}
                </button>
              </div>
            </div>
          ))
        ) : (
          <div
            className="no-results"
            style={{
              gridColumn: "1 / -1",
              textAlign: "center",
              padding: "40px",
              color: "#6b7280",
            }}
          >
            <h3>No institutions found</h3>
            <p>Try changing your filters</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default InstitutionsCom;
